// selection filter structure

import { FilterStateApi, SelectionFilterValues } from '../../../../../types'

export const getFilterCount = (filters: Record<string, SelectionFilterValues>, filterKey: string) =>
  filters[filterKey].length

// { key: [id, id, ...] }
export const updateFilter = ({
  filters,
  filterKey,
  flag,
  id
}: {
  filters: Record<string, SelectionFilterValues>
  filterKey: string
  id: string
  flag: boolean
}): FilterStateApi => ({
  [filterKey]: flag
    ? // add filter
      [...filters[filterKey], id]
    : // remove
      // upper case clause accounts for inconsistent keys in the dashboard api
      filters[filterKey].filter((it) => it !== id && it.toUpperCase() !== id.toUpperCase())
})

export const stateApi = {
  getFilterCount,
  updateFilter
}
